import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM12 20.5C7.305 20.5 3.5 16.695 3.5 12C3.5 7.305 7.305 3.5 12 3.5C16.695 3.5 20.5 7.305 20.5 12C20.5 16.695 16.695 20.5 12 20.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.72 8.47L10.25 13.94L8.27999 11.97C7.98699 11.678 7.51299 11.678 7.21999 11.97C6.92699 12.263 6.92699 12.738 7.21999 13.03L9.71999 15.53C10.013 15.823 10.487 15.823 10.78 15.53L16.78 9.53C17.072 9.237 17.072 8.762 16.78 8.47C16.487 8.177 16.012 8.177 15.72 8.47Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'CheckmarkFill');

export default Icon;
